import { render, staticRenderFns } from "./OutboxMessageListItem.vue?vue&type=template&id=64e61dde&scoped=true"
import script from "./OutboxMessageListItem.vue?vue&type=script&lang=js"
export * from "./OutboxMessageListItem.vue?vue&type=script&lang=js"
import style0 from "./OutboxMessageListItem.vue?vue&type=style&index=0&id=64e61dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e61dde",
  null
  
)

export default component.exports